(function Gallery3D() {
  'use strict';

  document.querySelectorAll('[data-gallery-media-model]').forEach(node => node.addEventListener('click', POV.utils.partial(init, node), {once: true}));

  function init(sliderItemNode) {
    POV.utils.compose(addLoadEndClass, createMarkup, addLoadStartClass)(sliderItemNode);
  } 

	/*
	Add class 'model-loading' class to the gallery slider item before the 'model-viewer' is defined and loaded.
	*/
  function addLoadStartClass(sliderItemNode) {
    sliderItemNode.classList.add('model-loading');
    return sliderItemNode;
  }

	/*
	Append the 'model-viewer' component markup to the gallery slider item.
	*/
  function createMarkup(sliderItemNode) {
    const template = sliderItemNode.querySelector('template');
    const clone = template.content.cloneNode(true);
    const picture = sliderItemNode.querySelector('picture');

    sliderItemNode.insertBefore(clone, picture);
    sliderItemNode.querySelector('model-viewer').removeAttribute('poster');

    return sliderItemNode;
  }

	/*
	Add class 'model-loaded to the gallery slider item after the 'model-viewer' is defined and loaded.
	*/
  function addLoadEndClass(sliderItemNode) {
    (async function addModelViewerLoadEvent() {
      
      // Wait for all model-viewer webcomponents to be defined
      const promise = new Promise((resolve) => {
        resolve(customElements.whenDefined('model-viewer'));
      });

      // On the defined model-viewer webcomponent 
      // add class 'model-loaded to the gallery slider item after the model is loaded.
      promise.then(() => {
        sliderItemNode.querySelector('model-viewer').addEventListener('load', ()=> sliderItemNode.classList.add('model-loaded'));
      });
    })();    
  }
	
})();